import { APIProvider, Map, Marker } from "@vis.gl/react-google-maps";
import { useState } from "react";
import { useCampuses } from "../../contexts/CampusContext";
import image1 from "../../images/1.jpg";
import image2 from "../../images/3.jpg";
import image3 from "../../images/4.jpg";
import image4 from "../../images/Prophet+Prophetess.jpg";
import headerIMG from "../../images/header-img.jpg";


const Welcome = () => {
  const [clickedIndex, setClickedIndex] = useState(null);
  const [mapVisibility, setMapVisibility] = useState(false);
  const {campuses} = useCampuses();

  function handleMouseClick(index) {
    setClickedIndex(null);
    setClickedIndex(index);
    if (index === null) {
      setMapVisibility(false);
    } else {
      setMapVisibility(true);
    }
  }
  
  return (
    <main className="flex flex-col gap-8">
      {/* Header Section with Dark Overlay */}
      <header 
        className="relative h-[50vh] sm:h-[80vh] bg-cover bg-center flex items-center justify-center mt-10"
        style={{ backgroundImage: "url(../../images/header-img.jpg)" }}
      >
        {/* Dark Overlay */}
        <div className="absolute inset-0 bg-black bg-opacity-50 z-0"></div>
        
        {/* Content */}
        <div className="relative z-10 flex flex-col items-center justify-center text-center px-4 w-[100%]">
          <h1 className="text-3xl sm:text-4xl md:text-5xl font-bold text-white mb-2 drop-shadow-md">
            Welcome to
          </h1>
          <h1 className="text-3xl sm:text-4xl md:text-5xl font-bold text-white mb-4 drop-shadow-md">
            The Home of Love
          </h1>
          <p className="text-white text-sm sm:text-base md:text-lg max-w-3xl drop-shadow-md">
            “...And now there remain: <span className="font-bold">Faith</span> [abiding trust in God and His promises],{" "}
            <span className="font-bold">Hope</span> [confident expectation of eternal salvation],{" "}
            <span className="font-bold">Love</span> [unselfish love for others growing out of God's love for me], these
            three; but <span className="font-bold">the greatest</span> of these three <span className="font-bold">is Love</span>” <br />
            ~ <span className="font-bold">I Corinthians 13:13</span>
          </p>
        </div>

        {/* Gallery Images - Hidden on mobile */}
        <div className="hidden sm:flex relative z-10 w-[50%] h-full items-center justify-center pointer-events-none">
          <img 
            src={image1} 
            className="absolute h-[130px] w-[180px] sm:h-[200px] sm:w-[250px] left-50 rounded border-2 border-white shadow-lg" 
            alt="" 
          />
          <img 
            src={image2} 
            className="absolute h-[70px] w-[100px] sm:h-[100px] sm:w-[150px] left-20 top-80 rounded border-2 border-white shadow-lg" 
            alt="" 
          />
          <img 
            src={image3} 
            className="absolute h-[70px] w-[100px] sm:h-[100px] sm:w-[150px] top-[80px] sm:top-[40%] right-20 rounded border-2 border-white shadow-lg" 
            alt="" 
          />
        </div>
        <img src={headerIMG} alt="header-img" className="absolute h-full w-full"></img>
        <div className="absolute inset-0 bg-black bg-opacity-80 z-0"></div>
      </header>

      {/* Who We Are Section */}
      <section className="container mx-auto bg-white shadow-lg rounded-lg p-0 overflow-hidden">
        <div className="flex flex-col sm:flex-row">
          <img 
            src={image2} 
            className="w-full sm:w-1/2 h-auto object-cover" 
            alt="Church gathering" 
          />
          <div className="p-4 sm:p-6">
            <h1 className="text-2xl font-serif italic mb-4">Who are we?</h1>
            <p className="text-gray-700">
            We are a Spirit-filled church, rooted deeply in the Word of the Lord and a life of prayer. We believe in the Lord Jesus Christ — the Son of the Living God — as our Savior, Redeemer, and soon-coming King. We uphold the truth of the Holy Scriptures and walk in obedience to the voice of the Holy Spirit. Our foundation is built on faith in God the Father, Jesus Christ the Son, and the guidance of the Holy Spirit, who empowers us to live righteously and fulfill the purpose God has set before us.
            </p>
          </div>
        </div>
      </section>

      {/* Services Section */}
      <section className="container bg-whitea p-0 shadow-lg rounded-lg overflow-hidden flex ">
        <div className="w-full sm:w-3/4 p-4">
          <h1 className="text-2xl font-serif italic mb-4">Our Services</h1>
          <div className="space-y-2">
            {campuses.map((campus, index) => (
              <div key={campus.key}>
                <div 
                  className={`p-4 cursor-pointer transition-all duration-300 rounded ${
                    clickedIndex === index 
                      ? "bg-primary text-white" 
                      : "hover:bg-gray-200"
                  }`}
                  onClick={() => handleMouseClick(index)}
                onTouchEnd={() => handleMouseClick(null)}
                onMouseUp={() => handleMouseClick(null)}
                >
                  <div className="font-medium text-lg">{campus.name}</div>
                  {clickedIndex === index && (
                    <div className="mt-2 text-sm">
                      {campus.time || '08h00'} <br />
                      Call: {campus.phone}, email: {campus.contactEmail}
                    </div>
                  )}
                </div>

                {/* Mobile-only map appears below clicked campus */}
                {clickedIndex === index && (
                  <div className="sm:hidden w-full h-[250px] mt-2">
                    <APIProvider apiKey="AIzaSyADZ4xvTeIRlQeIDceZra_mZ8so4C42azw">
                      <Map
                        defaultCenter={{
                          lat: campuses[clickedIndex].latitude,
                          lng: campuses[clickedIndex].longitude,
                        }}
                        defaultZoom={14}
                        gestureHandling={"greedy"}
                        disableDefaultUI={true}
                        className="w-full h-full rounded-lg"
                      >
                        <Marker position={{
                          lat: campuses[clickedIndex].latitude,
                          lng: campuses[clickedIndex].longitude,
                        }} />
                      </Map>
                    </APIProvider>
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>

        {/* Desktop map (appears at bottom for all campuses) */}
        {clickedIndex !== null && (
          <div className="hidden invisible sm:block sm:visible w-full bg-primary p-0 h-[500px]">
            <APIProvider apiKey="AIzaSyADZ4xvTeIRlQeIDceZra_mZ8so4C42azw">
              <Map
                defaultCenter={{
                  lat: campuses[clickedIndex].latitude,
                  lng: campuses[clickedIndex].longitude,
                }}
                defaultZoom={14}
                gestureHandling={"greedy"}
                disableDefaultUI={true}
                className="w-full h-full"
              >
                <Marker position={{
                  lat: campuses[clickedIndex].latitude,
                  lng: campuses[clickedIndex].longitude,
                }} />
              </Map>
            </APIProvider>
          </div>
        )}
      </section>

      {/* Pastors Section */}
      <section className="container mx-auto bg-white shadow-lg rounded-lg overflow-hidden flex flex-col sm:flex-row items-center">
        <div className="p-4 sm:p-6 flex-1">
          <div>
            <h1 className="text-2xl font-serif italic">Meet our pastors</h1>
            <h6 className="font-bold text-lg mt-2">Prophet P.R & Prophetess I.R Molaba</h6>
          </div>
          <p className="mt-4 text-gray-700">
          Prophet P.R. Molaba and Prophetess I.R. Molaba are the visionary founders of Excellent Love Ministries. Their lives are marked by unwavering dedication to the call of God, with a burning passion for ministry, soul-winning, and raising leaders grounded in truth.

From humble beginnings — starting with home-cells in various households — they have faithfully led the ministry under the guidance of the Holy Spirit. Through their leadership, Excellent Love Ministries has grown into a Spirit-filled, multi-branch church rooted in the Word of God and prayer.

Their mandate is clear: to win souls, transform lives through the Word, and prepare people for the coming of Christ. They are committed to equipping believers, restoring hope, and spreading the love of God across communities both locally and beyond.

Their heart for evangelism, discipleship, and building strong faith-based communities continues to shape the mission and vision of the ministry to this day.
          </p>
        </div>
        <img
          src={image4}
          className="w-48 h-48 sm:w-64 sm:h-64 object-cover rounded-full m-4 sm:m-8 border-4 border-white shadow-lg"
          alt="Pastors"
        />
      </section>
    </main>
  );
};

export default Welcome;